// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2575":"b55b02d2","4472":"343edd30"}[chunkId] + ".chunk.css";
};